// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import DidItButtonModalManager, {
  type DidItButtonProps,
} from 'app/common/react/components/DidItButtonModalManager';
import { Box, Text } from 'gestalt';

type Props = {|
  isDoneByMe: boolean,
  loggedInUser: {
    username: string,
    id: string,
  },
  onToggleModal: (isShown: boolean) => void,
  pinId: string,
  pinTitle: string,
  aggregatedPinDataId: string,
  userDidItDataId: string,
|};

export function DidItEditFlyoutButton(props: Props) {
  return (
    <DidItButtonModalManager
      thriftComponentType={PCONST.thrift.ComponentType.DID_IT_EDIT}
      {...props}
    >
      {({ onTriedItButtonClick }: DidItButtonProps) => (
        <button
          style={{ background: 'none', border: 'none', padding: '0', width: '100%' }}
          onClick={onTriedItButtonClick}
        >
          <Box deprecatedPadding={{ y: 1, x: 2 }}>
            <Text size="md" weight="bold">
              {i18n._('Edit')}
            </Text>
          </Box>
        </button>
      )}
    </DidItButtonModalManager>
  );
}

export default DidItEditFlyoutButton;
